module.exports = __webpack_public_path__ + "img/kalilinux.53165356.png";